import { render, staticRenderFns } from "./DashboardScaleScoresView.vue?vue&type=template&id=05a95f66&"
import script from "./DashboardScaleScoresView.vue?vue&type=script&lang=js&"
export * from "./DashboardScaleScoresView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports